import changeCase from 'change-object-case';
import _ from 'lodash';

export class MessagePackCaseHelper {
   public static messagePackNormalizeObject<T>(object: T): T {
      return MessagePackCaseHelper.messagePackNormalizeObjectInternal(object);
   }

   private static messagePackNormalizeObjectInternal<T>(object: T): T {
      if (!_.isObject(object)) {
         return object;
      }

      const propertiesThatContainsDictionary = MessagePackCaseHelper.getPropertiesThatContainsDictionary(object);
      const propertiesThatContainsUnion = MessagePackCaseHelper.getPropertiesThatContainsUnion(object);

      _.keys(object).forEach((key) => {
         // Note: Workaround for directory hotkey combo settings.
         if (key.toLowerCase() === 'hotkeycombos') {
            propertiesThatContainsDictionary.push(key);
         }
         if (propertiesThatContainsUnion.includes(key)) {
            object[key] = MessagePackCaseHelper.removeMessagePackUnionLayer(object[key]);
         }
         const newKey = changeCase.lowerCaseFirst(key);
         if (propertiesThatContainsDictionary.includes(key)) {
            object[newKey] = MessagePackCaseHelper.camelCaseWithIgnoreFirstLevel(object[key]);
         } else {
            object[newKey] = MessagePackCaseHelper.messagePackNormalizeObjectInternal(object[key]);
         }
         if (key !== newKey) {
            delete object[key];
         }
      });
      return object;
   }

   private static removeMessagePackUnionLayer(object: any) {
      if (_.isArray(object) && _.size(object) === 2 && _.isNumber(object[0])) {
         return object[1];
      }
      _.keys(object).forEach((key) => {
         object[key] = object[key][1];
      });
      return object;
   }

   private static camelCaseWithIgnoreFirstLevel<T>(object: T): T {
      _.keys(object).forEach((key) => {
         object[key] = MessagePackCaseHelper.messagePackNormalizeObjectInternal(object[key]);
      });
      return object;
   }

   private static getPropertiesThatContainsDictionary(object: any): string[] {
      const listOfProperties = object.DictionaryProperties;
      if (_.isNil(listOfProperties)) {
         return [];
      }
      return listOfProperties;
   }

   private static getPropertiesThatContainsUnion(object: any): string[] {
      const listOfProperties = object.UnionProperties;
      if (_.isNil(listOfProperties)) {
         return [];
      }
      return listOfProperties;
   }
}
